(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamstatistics/assets/javascripts/models/statteamstatistics.js') >= 0) return;  svs.modules.push('/components/statistics/teamstatistics/assets/javascripts/models/statteamstatistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.StatTeamStatistics = Backbone.Model.extend({
    path: '',
    shift: '',
    players: [],
    teams: [],
    leagues: [],
    statistics: [],
    FETCH_STATISTICS: 'FETCH_STATISTICS',
    FETCH_CURRENT_LEAGUE: 'fetch_current_league',
    FETCH_TEAM_STATISTICS: 'fetch_team_statistics',

    ASSISTS: 'Assists',
    GOALS: 'Mål',
    MATCHES_PLAYED: 'Antal matcher',
    STARTING_XI: 'Startat',
    SUBSTITUTIONS_IN: 'Antal byten in',
    SUBSTITUTIONS_OUT: 'Antal byten ut',
    YELLOW_CARDS: 'Gula kort',
    RED_CARDS: 'Röda kort direkt',
    YELLOW_OR_RED_CARDS: 'Gula/Röda kort',
    TOTAL_RED_CARDS: 'Röda kort',

    currentState: null,
    numOfMatches: 5,
    initialize: function(options) {
      this.setCurrentState(this.FETCH_CURRENT_LEAGUE);
      this.currentTeamId = options.teamId;
      this.requestLeagueByTeamId = options.requestLeagueByTeamId;
      this.currentLeagueId = options.leagueId;
      this.set('originalTeamId', this.currentTeamId, { silent: true });
    },
    multifetchURL: function() {
      this.shift = this.attributes.shift;
      this.path = '';
      this.path += this.leagueStatisticsPath();
      this.path += this.playerStatisticsPath();
      this.path += this.statisticsPath();
      this.path += this.latestMatchesPath();
      this.path += this.teamsByLeagueIdPath();
      var s =
        svs.core.jupiter.url() +
        '/multifetch?urls=' +
        encodeURIComponent(this.path);
      return s;
    },
    currentLeagueFetchURL: function() {
      this.shift = this.attributes.shift;
      this.path = '';
      this.currentLeagueByTeamIDPath();
      var s = svs.core.jupiter.url() + '/multifetch?urls=' + this.path;
      s = s.substring(0, s.length - 1);
      return s;
    },
    teamStatisticsFetchURL: function() {
      this.shift = this.attributes.shift;
      this.path = '';
      this.path += this.teamStatisticsByTeamIdAndLeagueId();
      var s = svs.core.jupiter.url() + '/multifetch?urls=' + this.path;
      s = s.substring(0, s.length - 1);
      return s;
    },
    leagueStatisticsPath: function() {
      return '/sport/1/leagues/' + this.currentLeagueId + '/statistics|';
    },
    currentLeagueByTeamIDPath: function() {
      this.path += '/sport/1/teams/' + this.currentTeamId + '/current_leagues|';
    },
    statisticsPath: function() {
      var pathPart1 =
        '/sport/1/teams/' +
        this.currentTeamId +
        '/statistics?leagueid=' +
        this.currentLeagueId +
        '|';
      return pathPart1;
    },
    teamsByLeagueIdPath: function() {
      var pathPart = '/sport/1/leagues/' + this.currentLeagueId + '/teams';
      return pathPart;
    },
    playerStatisticsPath: function() {
      var pathPart =
        '/sport/1/leagues/' + this.currentLeagueId + '/playerstatistics|';
      return pathPart;
    },
    latestMatchesPath: function() {
      var pathPart =
        '/sport/1/teams/' + this.currentTeamId + '/lastmatches?count=10|';
      return pathPart;
    },
    teamStatisticsByTeamIdAndLeagueId: function() {
      var pathPart =
        'sport/1/teams/' +
        this.currentTeamId +
        '/leaguestatistics?leagueid=' +
        this.currentLeagueId +
        '|';
      return pathPart;
    },
    url: function() {
      return this.validateState();
    },
    setCurrentState: function(sCurrentState) {
      this.currentState = sCurrentState;
    },
    getCurrentState: function() {
      return this.currentState;
    },
    validateState: function() {
      var execState = null;
      switch (this.getCurrentState()) {
        case this.FETCH_STATISTICS:
          execState = this.multifetchURL();
          break;
        case this.FETCH_CURRENT_LEAGUE:
          execState = this.currentLeagueFetchURL();
          break;
        case this.FETCH_TEAM_STATISTICS:
          execState = this.teamStatisticsFetchURL();
          break;
        default:
          throw Error('no matching state');
      }
      return execState;
    },
    update: function(options) {
      this.currentTeamId = options.teamId;
      this.requestLeagueByTeamId = options.requestLeagueByTeamId;
      this.currentLeagueId = options.leagueId;
    },
    updateTeamFormLatest: function(callOptions, cb) {
      var urls = [];
      urls.push(
        '/sport/1/teams/' +
          this.currentTeamId +
          '/lastmatches?count=10&selection=' +
          callOptions.selection
      );

      var options = {
        method: 'GET',
        path: '/multifetch?urls=' + encodeURIComponent(urls.join('|'))
      };

      svs.core.jupiter.call(
        options,
        function(response) {
          cb(null, response);
        },
        function(error) {
          cb(error);
        }
      );
    },
    parse: function(response, selection) {
      var oRSP = {};
      var teamRSP = null;

      if (typeof selection !== 'string') {
        selection = 'all';
      }

      if (this.getCurrentState() === this.FETCH_TEAM_STATISTICS) {
        if (((response || {}).responses || {})[0]) {
          teamRSP = response.responses[0];
          if (
            !(teamRSP.teamStatistics || {}).team ||
            !(teamRSP.teamStatistics || {}).season ||
            !(teamRSP.teamStatistics || {}).playerStatistics
          ) {
            this.selection = selection || 'all';
            this.trigger('change', this);
            this.trigger('change:teamFormLatestMatches');
            return;
          }
        }

        if (
          teamRSP.teamStatistics.playerStatistics.keys.redCardsForTeam ||
          teamRSP.teamStatistics.playerStatistics.byKey.yellowOrRedcardsForTeam
        ) {
          teamRSP.teamStatistics.playerStatistics.keys.totalRedCardsForTeam =
            'Totalt antal röda kort';
          teamRSP.teamStatistics.playerStatistics.byKey.totalRedCardsForTeam = this.unionPlayerStats(
            teamRSP.teamStatistics.playerStatistics.byKey.redCardsForTeam || [],
            teamRSP.teamStatistics.playerStatistics.byKey
              .yellowOrRedcardsForTeam || []
          );
        }

        var _self = this;
        for (var i = 0; i < this.teams.length; i++) {
          if (this.teams[i].id === _self.currentTeamId) {
            this.teams[i] = {
              id: teamRSP.teamStatistics.team.id,
              name: teamRSP.teamStatistics.team.name,
              mediumName: teamRSP.teamStatistics.team.mediumName,
              shortName: teamRSP.teamStatistics.team.shortName,
              code: teamRSP.teamStatistics.team.code,

              season: teamRSP.teamStatistics.season,
              players: teamRSP.teamStatistics.playerStatistics.players,
              keys: this.translateKeys(
                teamRSP.teamStatistics.playerStatistics.keys
              ),
              byPlayer: teamRSP.teamStatistics.playerStatistics.byPlayer,
              byKey: teamRSP.teamStatistics.playerStatistics.byKey
            };
            break;
          }
        }
        this.playerStats.byTeam = this.teams;
        this.set('playerStatistics', this.playerStats, { silent: true });
        this.trigger('change', this);
        this.trigger('change:teamFormLatestMatches');
      } else if (this.getCurrentState() === this.FETCH_CURRENT_LEAGUE) {
        this.oCurrentLeagueByTeamId = this.parseCurrentLeagueByTeamId(response);
        return this.oCurrentLeagueByTeamId;
      } else if (this.getCurrentState() === this.FETCH_STATISTICS) {
        var oLeagueStatistics = this.parseLeagueStatistics(response);
        this.teams = this.parseTeamsByLeagueId(response);
        var oPlayerStatistics = this.parsePlayStatistics(response, this.teams);
        var oSpecialTeams = this.parseSpecialTeams(response);
        var oFormLatestStatistics = this.parseFormLatestMatchesStatistics(
          response,
          selection
        );
        this.playerStats = oPlayerStatistics;

        if (_.isObject(oLeagueStatistics)) {
          this.set('teams', oRSP.teams, { silent: true });
          this.set('teamsOffenseDefense', oLeagueStatistics.teams, {
            silent: true
          });
          this.set('playerStatistics', oPlayerStatistics, { silent: true });
          this.set('specialTeams', oSpecialTeams, { silent: true });
        }
        if (_.isObject(oFormLatestStatistics)) {
          if (_.isObject(oFormLatestStatistics.statistics)) {
            oRSP.statistics = oFormLatestStatistics.statistics;
          }
        }
        if (this.get('numberOfMatches') !== undefined) {
          this.numOfMatches = this.get('numberOfMatches');
        }

        if (_.isObject(oFormLatestStatistics.statistics)) {
          this.set('statistics', oFormLatestStatistics.statistics, {
            silent: true
          });
          this.trigger('change', this);
        }
      }
    },
    parseCurrentLeagueByTeamId: function(response) {
      var leagues = [];
      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isObject(multipart.leagues)) {
            leagues = multipart.leagues;
          }
        }
      });
      return { leagues: leagues };
    },
    parseLeagueStatistics: function(response) {
      this.playerStats = [];
      this.teamStats = [];
      var statistics = false;
      var me = this;
      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isObject(multipart.statistics)) {
            statistics = multipart.statistics;
            if (_.isObject(statistics.goalStatistics)) {
              me.teamStats = statistics.goalStatistics;
            }
          }
        }
      });
      return { teams: this.teamStats };
    },
    parseSpecialTeams: function(response) {
      var statistics = false,
        specialTeams;

      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isObject(multipart.teamRoster)) {
            statistics = multipart.teamRoster;
            if (_.isObject(statistics.specialTeams)) {
              specialTeams = statistics.specialTeams;

              if (((specialTeams || {}).powerplay || {}).ratio) {
                specialTeams.powerplay.ratio = Math.round(
                  parseFloat(specialTeams.powerplay.ratio) * 100
                );
              }

              if (((specialTeams || {}).penaltykill || {}).ratio) {
                specialTeams.penaltykill.ratio = Math.round(
                  parseFloat(specialTeams.penaltykill.ratio) * 100
                );
              }

              if (
                !((specialTeams || {}).powerplay || {}).ratio ||
                !((specialTeams || {}).penaltykill || {}).ratio
              ) {
                specialTeams = null;
              }
            }
          }
        }
      });
      return specialTeams;
    },
    parsePlayStatistics: function(response, teams) {
      var playerStatistics = false;
      var playerStatsByLeague = [];
      var _self = this;
      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isObject(multipart.statistics)) {
            playerStatistics = multipart.statistics;
            if (_.isObject(playerStatistics.keys)) {
              if (
                playerStatistics.keys.redCardsInTournament ||
                playerStatistics.byKey.yellowOrRedcardsInTournament
              ) {
                playerStatistics.keys.totalRedCardsInTournament =
                  'Totalt antal röda kort';
                playerStatistics.byKey.totalRedCardsInTournament = _self.unionPlayerStats(
                  playerStatistics.byKey.redCardsInTournament || [],
                  playerStatistics.byKey.yellowOrRedcardsInTournament || []
                );
              }
              playerStatistics.keys = _self.translateKeys(
                playerStatistics.keys
              );
            }
            var players = playerStatistics.players;
            if (_.isObject(players)) {
              playerStatsByLeague = playerStatistics;
            }
          }
        }
      });
      var byTeamList = teams;
      byTeamList = _.sortBy(byTeamList, 'name');
      playerStatsByLeague.byTeam = byTeamList;
      return playerStatsByLeague;
    },
    parseTeamsByLeagueId: function(response) {
      var teamData = false;
      _.each(response.responses, function(multipart) {
        if (_.isObject(multipart) && multipart.error === null) {
          if (_.isArray(multipart.teams)) {
            teamData = multipart.teams;
          }
        }
      });
      return teamData;
    },
    parseFormLatestMatchesStatistics: function(response, selection) {
      var statistics = false;

      if (typeof selection !== 'string') {
        selection = 'all';
      }

      _.each(
        response.responses,
        function(multipart) {
          if (_.isObject(multipart) && multipart.error === null) {
            if (_.isObject(multipart.result)) {
              selection = selection || 'all';
              statistics = {};
              statistics.latestMatches = {};
              statistics.latestMatches[selection] = multipart.result;

              if (statistics.latestMatches[selection]) {
                _.each(statistics.latestMatches[selection], function(
                  matchItem
                ) {
                  matchItem.formatedStartTime = moment(
                    matchItem.match.startTime
                  ).format('D/M, YYYY');
                });
              }
            }
          }
        },
        this
      );
      return { statistics: statistics };
    },
    translateKeys: function(keys) {
      var theKey = null;
      for (var i in keys) {
        if (Object.prototype.hasOwnProperty.call(keys, i)) {
          theKey = i;
          if (theKey === 'assistsForTeam' || theKey === 'assistsInTournament') {
            keys[i] = this.ASSISTS;
          } else if (
            theKey === 'goalsForTeam' ||
            theKey === 'goalsIntournament'
          ) {
            keys[i] = this.GOALS;
          } else if (
            theKey === 'matchesPlayedForTeam' ||
            theKey === 'matchesPlayedIntournament'
          ) {
            keys[i] = this.MATCHES_PLAYED;
          } else if (theKey === 'startingXI') {
            keys[i] = this.STARTING_XI;
          } else if (theKey === 'substitutionsIn') {
            keys[i] = this.SUBSTITUTIONS_IN;
          } else if (theKey === 'substitutionsOut') {
            keys[i] = this.SUBSTITUTIONS_OUT;
          } else if (
            theKey === 'yellowCardsForTeam' ||
            theKey === 'yellowCardsInTournament'
          ) {
            keys[i] = this.YELLOW_CARDS;
          } else if (
            theKey === 'redCardsForTeam' ||
            theKey === 'redCardsInTournament'
          ) {
            keys[i] = this.RED_CARDS;
          } else if (
            theKey === 'yellowOrRedcardsForTeam' ||
            theKey === 'yellowOrRedcardsInTournament'
          ) {
            keys[i] = this.YELLOW_OR_RED_CARDS;
          } else if (
            theKey === 'totalRedCardsForTeam' ||
            theKey === 'totalRedCardsInTournament'
          ) {
            keys[i] = this.TOTAL_RED_CARDS;
          }
        }
      }
      return keys;
    },
    unionPlayerStats: function(a, b) {
      var union = _.union(a, b);
      var groups = _(union).groupBy('playerId');
      var out = _(groups).map(function(g, key) {
        return {
          playerId: key,
          value: _(g).reduce(function(m, x) {
            return m + parseInt(x.value, 10);
          }, 0)
        };
      });
      return out;
    },
    hasData: function() {
      return this.fetched;
    },
    setCurrentTeam: function(teamId) {
      this.setCurrentState(this.FETCH_TEAM_STATISTICS);
      var _self = this;
      this.currentTeamId = teamId;
      this.set('currentTeamId', this.currentTeamId, { silent: true });
      this.fetch({
        error: function() {
          _self.trigger('change', _self);
        }
      });
    },
    setCurrentStatistics: function(teamId, leagueId) {
      this.setCurrentState(this.FETCH_STATISTICS);
      var _self = this;
      this.currentTeamId = teamId;

      var leagues = this.get('leagues');
      for (var i = 0; i < leagues.length; i++) {
        if (leagues[i].id === leagueId) {
          this.set('sport', leagues[i].sport, { silent: true });
          break;
        }
      }

      this.set('currentTeamId', this.currentTeamId, { silent: true });
      this.currentLeagueId = leagueId;
      this.fetch({
        error: function() {
          _self.trigger('change', _self);
        }
      });
    },
    setCurrentLeague: function() {
      this.setCurrentState(this.FETCH_CURRENT_LEAGUE);
      var _self = this;
      this.fetch({
        error: function() {
          _self.trigger('change', _self);
        }
      });
    }
  });
})(Backbone, _, svs);

 })(window);